import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import successAnimation from '../../../Animations/Animation.json'; // Add a JSON Lottie file or use any animation you like
import './PaymentSuccess.css';

function PaymentSuccess() {
  const navigate = useNavigate();

  const handleHomeRedirect = () => {
    navigate('/'); // Redirect to the home page
  };

  return (
    <div className="payment-success">
      <div className="animation-container">
        <Lottie animationData={successAnimation} loop={false} />
      </div>
      <h1 className="thank-you-message">Thank you for your payment!</h1>
      <p className="description">
        Your transaction was successful. We appreciate your prompt payment.
      </p>
      <Button type="primary" className="home-button" onClick={handleHomeRedirect}>
        Return Home
      </Button>
    </div>
  );
}

export default PaymentSuccess;
